function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dbtiinzuca",
  d: "M8 2.667c2.944.003 5.33 2.389 5.333 5.333 0 2.946-2.387 5.333-5.333 5.333S2.667 10.946 2.667 8 5.054 2.667 8 2.667zm0 .762C5.475 3.429 3.429 5.475 3.429 8S5.475 12.571 8 12.571c2.524-.002 4.569-2.047 4.571-4.571 0-2.525-2.046-4.571-4.571-4.571zm.508 1.65c.21 0 .38.17.38.381v3.048c0 .21-.17.38-.38.38H5.46c-.21 0-.38-.17-.38-.38s.17-.381.38-.381h2.667V5.46c0-.21.17-.38.38-.38z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-32 -149) translate(32 149)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3myjlb70xb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dbtiinzuca"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  xlinkHref: "#dbtiinzuca"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#3myjlb70xb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H16V16H0z",
  transform: "rotate(90 8 8)"
})))));

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.07ce6a7a.svg";
export { ForwardRef as ReactComponent };